import { api, apiPublic } from "@/frontend/services/api";
import type { ApiResponse } from "@/shared/dto";

const BASE_URL_PRIVATE = "/invitations/private";
const BASE_URL_PUBLIC = "/invitations";

export interface SendInvitationRequestDTO {
  email: string;
  poolId: string;
}

export interface InvitationResponseDTO {
  id: string;
  email: string;
  poolId: string;
  poolName?: string;
  token: string;
  invitedBy: string;
  inviterName?: string;
  status: "pending" | "accepted" | "expired" | "canceled";
  expiresAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface ValidateInvitationResponseDTO {
  poolId: string;
  poolName: string;
  emailInvited: string;
  inviterName: string;
  isExpired: boolean;
  status: "pending" | "accepted" | "expired" | "canceled";
}

export interface AcceptInvitationRequestDTO {
  token: string;
}

export interface PoolParticipantResponseDTO {
  poolId: string;
  userId: string;
  invitedBy?: string | null;
  role: string;
  status: string;
  joinedAt?: string | null;
  exitReason?: string | null;
  updatedAt: string;
  createdAt: string;
}

export const poolInvitationService = {
  send: (data: SendInvitationRequestDTO) =>
    api.post<ApiResponse<InvitationResponseDTO>>(`${BASE_URL_PRIVATE}/send`, data),

  validate: (token: string) =>
    apiPublic.get<ApiResponse<ValidateInvitationResponseDTO>>(`${BASE_URL_PUBLIC}/validate/${token}`),

  accept: (data: AcceptInvitationRequestDTO) =>
    api.post<ApiResponse<PoolParticipantResponseDTO>>(`${BASE_URL_PRIVATE}/accept`, data),

  resend: (invitationId: string) =>
    api.post<ApiResponse<InvitationResponseDTO>>(`${BASE_URL_PRIVATE}/${invitationId}/resend`),

  cancel: (invitationId: string) =>
    api.patch<ApiResponse<{ message: string }>>(`${BASE_URL_PRIVATE}/${invitationId}/cancel`),
};
